import {useUserContext} from "../../contexts";

export const useWhatsAppRedirect = () => {
    // Feature data
    const [{}, {}, {}, {
        contacts
    }] = useUserContext();

    return {
        data: contacts?.whatsapp
    }
}
